import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { uploadMedicalReport } from "../../services/consultationService";

export const usePdfUpload = (consulatationId, headers, onSuccess) => {
    const [showPdfUpload, setShowPdfUpload] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const [pdfDragActive, setPdfDragActive] = useState(false);
    const [isUploadingPdf, setIsUploadingPdf] = useState(false);

    const handlePdfUploadOpen = () => {
        setShowPdfUpload(true);
        setPdfFile(null);
    };

    const handlePdfUploadClose = () => {
        setShowPdfUpload(false);
        setPdfFile(null);
        setPdfDragActive(false);
    };

    const handlePdfFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type !== "application/pdf") { toast.error("Only PDF files are allowed."); return }
            if (file.size > 10 * 1024 * 1024) { toast.error("File size must be less than 10MB."); return }
            setPdfFile(file);
        }
    };

    const handlePdfDragEvents = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragover" || e.type === "dragenter") { setPdfDragActive(true) }
        else if (e.type === "dragleave" || e.type === "drop") { setPdfDragActive(false) }
    }, []);

    const handlePdfDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setPdfDragActive(false);
        const file = e.dataTransfer.files[0];
        if (file) {
            if (file.type !== "application/pdf") { toast.error("Only PDF files are allowed."); return }
            if (file.size > 10 * 1024 * 1024) { toast.error("File size must be less than 10MB."); return }
            setPdfFile(file);
        }
    }, []);

    const handlePdfUploadSubmit = async () => {
        if (!pdfFile || !consulatationId) { toast.error("Please select a PDF file to upload."); return }
        setIsUploadingPdf(true);
        try {
            const responseData = await uploadMedicalReport(pdfFile, consulatationId, headers);
            if (responseData && responseData.status) {
                toast.success(responseData.message || "PDF uploaded successfully!");
                if (onSuccess) onSuccess();
                handlePdfUploadClose();
            }
            else { toast.error(responseData?.error || "Failed to upload PDF.") }
        }
        catch (error) {
            console.error("PDF upload error:", error);
            toast.error("An error occurred while uploading.");
        }
        finally { setIsUploadingPdf(false) }
    };

    return {
        showPdfUpload,
        setShowPdfUpload,
        pdfFile,
        setPdfFile,
        pdfDragActive,
        isUploadingPdf,
        handlePdfUploadOpen,
        handlePdfUploadClose,
        handlePdfFileChange,
        handlePdfDragEvents,
        handlePdfDrop,
        handlePdfUploadSubmit
    };
};